import {FormatQuote} from "@mui/icons-material";
import {Card, Stack, Typography} from "@mui/material";
import axios from "axios";
import React from "react";
import {red_900} from "./js/APXTheme.js";


const endpoint = "https://api.quotable.io/random?tags=motivational|inspirational";


const authorKey = "author";
const contentKey = "content";

export type Quote = {
	  author: string;
	  content: string;
}

const fetchCodeByAxios = (onFetched: (quote: Quote)=>void) => {
	  axios.get(endpoint)
				 .then(
							(response) => {
								  const data = response.data;
								  const quote: Quote = {
										 author: data[authorKey],
										 content: data[contentKey]
								  };
								  onFetched(quote);
							},
							(error) => {
								  console.log(error);
							}
				 );
};


export default function APXQuotesFetcher() {
	  const [quote: Quote, setQuote] = React.useState(null);
	  React.useEffect(() => {
			 fetchCodeByAxios((quote) => {
					setQuote(quote);
			 });
	  }, []);
	  return (
				 <>
						{/*TRUTHY->*/ !!quote &&
								  <Card variant={"outlined"} sx={{p: 1, my: 2, borderColor: red_900}}>
										 <FormatQuote sx={{transform: "rotate(180deg)", opacity: 0.5}}/>
										 <Stack spacing={0.5} alignItems={"stretch"} justifyContent={"center"}>
												<Typography px={2} fontSize={12} align={"justify"} fontStyle={"italic"}>{quote.content}</Typography>
												<Typography px={2} fontSize={10} align={"right"}>- {quote.author}</Typography>
										 </Stack>
										 <Stack direction={"row"} justifyContent={"right"}><FormatQuote sx={{opacity: 0.5}}/></Stack>
										 <Typography align={"center"} fontSize={8}>Powered by <a href={"https://quotable.io/"} target={"_blank"}>Quotable API</a></Typography>
								  </Card>
						}
				 </>
	  );
}
